export default __webpack_public_path__ + "static/media/citi-color.8c049cad.svg";